import { memo, useCallback, useState } from 'react';
import { cn } from '@divlab/divanui';

import VideoIframe from '@Components/VideoIframe';
import VideoPreview from '@Components/VideoPreview';
import styles from './VideoPlayer.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface VideoPlayerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  cnPreview?: string;
  preview?: string;
  title?: string;
  video: string;
}

const VideoPlayer: FC<VideoPlayerProps> = (props) => {
  const { className, video, preview, title, cnPreview } = props;
  const [isPlaying, setIsPlaying] = useState(false);

  const handleClickPlay = useCallback(() => {
    setIsPlaying(true);
  }, []);

  return (
    <div className={cn(styles.videoContent, className)}>
      {isPlaying ? (
        <VideoIframe className={styles.videoWrapper} src={video} title={title} />
      ) : (
        <VideoPreview
          src={preview}
          cnPreviewHeight={cn(styles.preview, cnPreview)}
          onClick={handleClickPlay}
        />
      )}
    </div>
  );
};

export default memo(VideoPlayer);
